<template>
  <div class="search-page-c">
    <div class="toTop">
      <img src="" alt="">
    </div>
    <!-- 搜多栏 -->
    <div class="search-box">
      <van-search 
        :left-icon="searchIcon"
        v-model="search"  
        clearable 
        @search="onSearch"/>
    </div>
    <!-- 内容展示 -->
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <!-- 内容列表 -->
        <van-list
          class="article_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <div class="article-box">
            <div class="article" v-for="(item,index) in articleList" :key="index">
<!-- 搜索全部的内容 -->
              <div class="allType" v-if="fileTypeChecked == '1'">
        <!-- ART -->
                <div class="is-article" v-if="item.contentType == 'ART'" @click="goToDetails(item.artcId,item.coverLink)">
                  <div class="article-left">
                    <div class="article-title">
                      <img src="./img/article.png" alt="">
                      <p>{{item.title}}</p>
                    </div>
                    <div class="article-info">
                      <!-- <div>{{item.pubDate | getPushDate}} </div> -->
                      <div>阅读{{item.viewCount || 0}}次</div>
                      <div>转发{{item.fwdCount || 0}}次</div>
                    </div>
                  </div>
                  <div class="article-right">
                    <img :src=item.coverLink alt="">
                  </div>
                </div>
        <!-- PAW -->
                <div class="pic-art" v-if="item.contentType == 'PAW'">
                  <div class="title-top">
                  <wx-open-launch-weapp
                  id="launch-btn"
                  class="launch-btn"
                  username="gh_255fbfe5e3a1"
                  :path="minUrl+item.artcId+'&wx_openId='+openId"
                  >
                    <script type="text/wxtag-template">
                      <style>
                      .btn {line-height:44px;color:#fff;background:#000;width:100%;}
                      </style>
                      <div class='btn'>打开小程序</div>
                    </script>
                  </wx-open-launch-weapp>

                    <img src="./img/pic-art.png" alt="">
                    <p>{{item.artcSummary || '图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文'}}</p>
                  </div>
                  <div class="pic-mid">
                    <img :src="item.imgUrl1" alt="">
                  </div>
                  <div class="info-bot">
                    <!-- <div>{{item.pubDate | getPushDate}} </div> -->
                    <div>阅读{{item.viewCount || 0}}次</div>
                    <div>转发{{item.fwdCount || 0}}次</div>
                  </div>
                </div>
        <!-- VOD -->
                <div class="art-video" v-if="item.contentType == 'VOD'" @click="toVideo('inner',item.artcId)">
                  <div class="title-top">
                    <img src="./img/video.png" alt="">
                    <p>{{item.artcSummary || '视频样式'}}</p>
                  </div>
                  <div class="pic-mid" >
                    <div class="showBtn" ref="playBtn">
                      <img src="./img/play.png" alt="">
                    </div>
                    <video
                      ref="video" 
                      :src =item.videoSrc
                      :poster =item.faceImgUrl>
                    </video>
                  </div>
                  <div class="info-bot" > 
                    <!-- <div>{{item.pubDate | getPushDate}} </div> -->
                    <div>阅读{{item.viewCount || 0}}次</div>
                    <div>转发{{item.fwdCount || 0}}次</div>
                  </div>
                </div>
              </div>
<!-- 搜索文章的内容 -->
          <!-- 标题加右边缩略图 -->
              <div class="is-article" v-if="fileTypeChecked == '2'" @click="goToDetails(item.artcId,item.coverLink)">
              <div class="article-left">
                <div class="article-title">
                  <img src="./img/article.png" alt="">
                  <p>{{item.title}}</p>
                </div>
                <div class="article-info">
                  <!-- <div>{{item.pubDate | getPushDate}} </div> -->
                  <div>阅读{{item.viewCount || 0}}次</div>
                  <div>转发{{item.fwdCount || 0}}次</div>
                </div>
              </div>
              <div class="article-right">
                <img :src=item.coverLink alt="">
              </div>
            </div>
<!-- 搜索图文的内容 -->
              <div class="pic-art" v-if="fileTypeChecked == '3'">
                <div class="title-top">
                  <wx-open-launch-weapp
                  id="launch-btn"
                  class="launch-btn"
                  username="gh_255fbfe5e3a1"
                  :path="minUrl+item.artcId+'&wx_openId='+openId"
                  >
                    <script type="text/wxtag-template">
                      <style>
                       .btn {line-height:44px;color:#fff;background:#000;width:100%;}
                      </style>
                      <div class='btn'>打开小程序</div>
                    </script>
                  </wx-open-launch-weapp>
                  <img src="./img/pic-art.png" alt="">
                  <p>{{item.artcSummary || '图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文图文'}}</p>
                </div>
                <!-- 一张图 -->
                <div class="pic-mid" v-if="!item.imgUrl2">
                  <img :src="item.imgUrl1" @click="sceneImg([item.imgUrl1],0)"  alt="">
                </div>
                <!-- 九宫格形式 -->
                <div v-else class="nineGrid">
                  <img :src="item.imgUrl1" @click="sceneImg([item.imgUrl1],0)" alt="">
                  <img v-if="item.imgUrl2" :src="item.imgUrl2" @click="sceneImg([item.imgUrl2],0)" alt="">
                  <img v-if="item.imgUrl3" :src="item.imgUrl3" @click="sceneImg([item.imgUrl3],0)" alt="">
                  <img v-if="item.imgUrl4" :src="item.imgUrl4" @click="sceneImg([item.imgUrl4],0)" alt="">
                  <img v-if="item.imgUrl5" :src="item.imgUrl5" @click="sceneImg([item.imgUrl5],0)" alt="">
                  <img v-if="item.imgUrl6" :src="item.imgUrl6" @click="sceneImg([item.imgUrl6],0)" alt="">
                  <div class="eightGrid" v-if="item.imgUrl7">
                    <img v-if="item.imgUrl7" :src="item.imgUrl7" @click="sceneImg([item.imgUrl7],0)" alt="">
                    <img v-if="item.imgUrl8" :src="item.imgUrl8" @click="sceneImg([item.imgUrl8],0)" alt="">
                    <img v-if="item.imgUrl9" :src="item.imgUrl9" @click="sceneImg([item.imgUrl9],0)" alt="">
                  </div>
                </div>
                <div class="info-bot">
                  <!-- <div>{{item.pubDate | getPushDate}} </div> -->
                  <div>阅读{{item.viewCount || 0}}次</div>
                  <div>转发{{item.fwdCount || 0}}次</div>
                </div>
              </div>
<!-- 搜索视频的内容 -->
              <div class="art-video" v-if="fileTypeChecked == '4' && item.contentType == 'VOD'" @click="toVideo('inner',item.artcId)">
                <div class="title-top" >
                  <img src="./img/video.png" alt="">
                  <p>{{ item.vtitle||item.artcSummary}}</p> 
                </div>
                <div class="pic-mid" >
                  <!-- <img :src="item.faceImgUrl" alt=""> -->
                  <div class="showBtn" ref="playBtn">
                    <img src="./img/play.png" alt="">
                  </div>
                  <video
                    ref="video" 
                    :src =item.vodUrl
                    :poster="item.faceImgUrl"
                    >
                  </video>
                </div>
                <div class="info-bot" > 
                  <!-- <div>{{item.pubDate | getPushDate}} </div> -->
                  <div>阅读{{item.viewCount || 0}}次</div>
                  <div>转发{{item.fwdCount || 0}}次</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  import URL from "@/api/api";
  import {Search,PullRefresh,Toast,ImagePreview} from 'vant'
  import wx from "weixin-js-sdk"

  export default {
    name: "home",
    comments: {
      Search , PullRefresh,Toast 
    },
    data() {
      return {
        loading:false,
        finished:false,
        finishedText:'',
        refreshing:false,
        searchIcon:require('./img/search.png'),
        search:'',// 搜索文字
        row_num: 12, // 每页请求数量
        pageNum: 0, //请求第几页
        tabTypeChecked: '推荐', // 分类标签
        fileTypeChecked: '', // 搜索的类型
        openId: '',
        articleList: [], // 文章列表
        minUrl:"pages/sharePage/articlePage/articleShare.html?artcId=",//  小程序跳转页面路径

      }
    },
    created() {
      this.share()
      this.openId=sessionStorage.getItem('openId')
      // this.checkAuth()//先检测是否有相应的权限
    },
    mounted() {
      this.openId = sessionStorage.getItem("openId")
      this.search = this.$route.query.search;
      this.fileTypeChecked = this.$route.query.fileTypeChecked
      this.tabTypeChecked = this.$route.query.teb_type
      this.getArticleList()
      this.share()

    },
    filters: {
      getPushDate: function(str){
        let dateStr = new Date(str)
        let Y = dateStr.getFullYear() + "-"
        let M =
          (dateStr.getMonth() + 1 < 10
            ? "0" + (dateStr.getMonth() + 1)
            : dateStr.getMonth() + 1) + "-"
        let D = dateStr.getDate()
        return Y + M + D
      }
    },
    methods: {
      // 搜索
      onSearch(){
        this.pageNum = 0;
        this.getArticleList()
      },
      // 眺往抖音模式
      toVideo(type,artcId) {
        //跳转到视频页面
        let nowpage = 0
        let index = 0
        this.$router.push({
          name: "video",
          query: {
            articleId: artcId
          }
        })
      },
      // 获取文章列表
      getArticleList() {
        Toast.loading({
          message: "加载中...",
          duration: 0,
          forbidClick: true
        });
        this.$fetchPost(URL.searchPageArticle.url, {
          title: this.search, // 搜索关键字
          now_page: this.pageNum, // 请求第几页
          row_num: this.row_num, // 每页显示多少条
          open_id: this.openId,
          teb_type: this.tabTypeChecked, // 标签类型
          file_type: this.fileTypeChecked // 搜索文件类型
        }).then(res => {
          Toast.clear()
          const list = res.data;
          this.refreshing = false
          this.loading = false
          if(list == null || list.length == 0){
            // 加载结束
            this.finished = true;
            this.finishedText = '没有更多内容了'
            return;
          }
          // 如果本次请求的数据不足每页规定数量，加载结束
          if(list.length < this.row_num){
            this.finished = true;
            this.finishedText = '没有更多内容了'
          }
          // 合并数据
          if(this.pageNum > 0 ){
            this.articleList = [...this.articleList,...res];
          }else{
            this.articleList = list; 
          }
        })
      },
      // 列表触底加载
      onLoad(){
        this.pageNum ++ ;
        this.getArticleList()
      },
      // 下拉刷新
      onRefresh(){
        this.pageNum = 0;
        this.getArticleList();
      },
      // 详情页
      goToDetails(id, imgUrl) {
        this.$router.push({
          name: "articleDetails",
          query: {
            articleId: id,
            picUrl: imgUrl,
            openId: sessionStorage.getItem("openId"),
            canBack: "y"
          }
        })
      },
      sceneImg(images,index) {
        ImagePreview({
        images:images, //需要预览的图片 URL 数组
        showIndex:true, //是否显示页码
        loop:false, //是否开启循环播放
        startPosition:index //图片预览起始位置索引
        })
      },
      share(title, desc, shareLink, shareImg) {
        let that = this;
        let url = location.href.split("#")[0];
        this.$fetchGet(URL.articleShare.url, { url: url }).then(res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: [
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "hideMenuItems"
            ], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-weapp"] // 跳转小程序时必填
          });
          wx.ready(function() {
            wx.onMenuShareAppMessage({
              title: title, // 分享标题
              desc: desc, // 分享描述
              link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareImg, // 分享图标s
              type: "link", // 分享类型,music、video或link，不填默认为link
              success: function() {
                // 用户确认分享后执行的回调函数

              },
              cancel: function() {}
            });
            wx.onMenuShareTimeline({
              title: title, // 分享标题
              link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareImg, // 分享图标
              success: function() {

              }
            });
          });
        });
      },


      // 跳转小程序
      // handleLaunchFn(e) {
      // },
      handleErrorFn(e) {
      },
      
    }
  }
</script>

<style lang="less" scoped>
  .launch-btn{
    width: 100vw;
    height: 40px;
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.0);
    opacity: 0;

    // opacity: 0;
  }
  .search-page-c{
    // width: 100%;
    height: 100%;
    padding: 54px 16px 20px;
    background: #fff;
    .search-box{
      z-index: 1000;
      width: 92%;
      background: white;
      position: fixed;
      top: 0;
      padding-top: 16px;
      .van-search{
        padding: 0;
        height: 32px;
        border-radius: 4px;
        overflow: hidden;
        /deep/.van-icon__image{
        color:#333333!important;
        width: 24px;
        height: 24px;
        .van-search__content{
          padding-left: 12px;
        }
      }
      
      }
    }
    .content{
      .article-box{
        width: 100%;
        overflow: hidden;
// 搜索文章的样式
        .is-article{
          display: flex;
          // flex-direction: column;
          justify-content: space-between;
          width: 100%;
          padding: 15px 0;
          border-bottom: 1px solid #E5E5E5;
          .article-left{
            width: 70%;
            position: relative;
            // margin-bottom: 8px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            .article-title{
              margin-bottom: 14px;
              p{
                font-size: 16px;
                line-height: 22px;
                font-weight: 500;
                text-indent: 32px;
                color: #333333;
                // 省略号
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              img{
                display: block;
                width: 28px;
                height: 16px;
                position: absolute;
                top: 2px;
                left: 0;
              }

            }
            .article-info{
              font-size: 11px;
              line-height: 11px;
              color: #666666;
              display: flex;
              div{
                margin-right: 9px;
              }
            }
          }
          .article-right{
            width: 92px;
            height: 69px;
            border-radius: 4px;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
// 搜索图文的样式
        .pic-art{
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          // height: 282px;
          padding: 16px 0;
          border-bottom: 1px solid #E5E5E5;
          .title-top{
            position: relative;
            // margin-bottom: 12px;
            img{
              width: 26px;
              height: 16px;
              position: absolute;
              top: 1px;
            }
            p{
              font-size: 16px;
              line-height: 20px;
              font-weight: 500;
              color: #333333;
              text-indent: 34px;
              // 省略号
              overflow : hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .pic-mid{
            width: 100%;
            height: 182px;
            border-radius: 4px;
            overflow: hidden;
            margin: 12px 0;
            img{
              display: block;
              width: 100%;
              height: 100%;
              
              object-fit: cover;
            }
          }
          .nineGrid{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 12px 0;
            img{
              width: 109px;
              height: 82px;
              margin-bottom: 8px;
              object-fit: cover;
              border-radius: 4px;
            }
            .eightGrid{
              display: flex;
              justify-content: space-between;
              :nth-child(1){
                margin-right: 8px;
              }
              :nth-child(2){
                margin-right: 8px;
              }
            }
          }
          .info-bot{
            display: flex;
            font-size: 11px;
            line-height: 11px;
            color: #666666;
            div{
              margin-right: 9px;
            }
          }
        }
// 搜索视频的内容
        .art-video{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 16px 0;
          border-bottom: 1px solid #E5E5E5;
          .title-top{
            position: relative;
            img{
              width: 26px;
              height: 16px;
              position: absolute;
              top: 1px;
            }
            p{
              font-size: 16px;
              line-height: 20px;
              font-weight: 500;
              color: #333333;
              text-indent: 34px;
              // 省略号
              overflow : hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .pic-mid{
            width: 343px;
            height: 193px;
            position: relative;
            margin: 16px 0;
            video{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .hiddenBtn{
              display: none;
            }
            .showBtn{
              position: absolute;
              top: 0;
              bottom: 10px;
              left: 0;
              right: 0;
              margin: auto;
              z-index: 100;
              width: 48px;
              height: 48px;
              background-size: cover;
              img{
                display: block;
                width: 100%;
                height: 100%;
              }
            }
          }
          .info-bot{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            div{
              font-size: 11px;
              line-height: 11px;
              color: #666666;
              margin-right: 9px;
            }
          }
        }
      }
    }
  }
</style>
